function containsId(items, id) {
  return Boolean(items?.some((item) => item.id === id));
}

export function canOpenProjectDetail(data, projectId) {
  return containsId(data.allProjects, projectId);
}

export function canOpenClientDetail(data, clientId) {
  return containsId(data.clients, clientId);
}

export function canOpenUserDetail(data, userId) {
  return containsId(data.users, userId);
}
